<template>
  <div>
    <modal ref="modal" :show-modal="true" :closeCallback="closeCallback">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <h3 class="col mb-0">{{ $t('importtask.generate') }}</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <form-container
                ref="formContainer_popup"
                v-bind:model-state="modelState"
                v-bind:error-message="formError"
                :enabled="true"
                :orientation="'horizontal'"
              >
                <div class="row container-fluid">
                  <div class="col">
                    <list-input
                      v-show="destination === 10"
                      v-bind="formItems.LocationTypeID"
                      v-model="formItems.LocationTypeID.value"
                    />
                    <list-input
                      v-show="destination === 13"
                      v-bind="formItems.ObjectTypeID"
                      v-model="formItems.ObjectTypeID.value"
                    />
                  </div>
                </div>
              </form-container>
            </div>
          </div>
          <div class="row">
            <div class="col text-right">
              <loading-button
                :title="$t('generate')"
                @click="generate"
                :is-busy="false"
              ></loading-button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import formmixin from '@/forms/components.js';
import {
  FormBooleanConfig,
  FormControl,
  FormConfig,
  FormNumericConfig,
  FormTextConfig,
  ListFormConfig
} from 'libs/classes/form.js';

import { i18n } from '@/localize';

import { ObjectType, LocationType } from '@/libs/listconfigs';
import ModalComponent from '@/pages/app/MI/components/Modal.vue';

const form = new FormControl();
form.add( new ListFormConfig( 'ObjectTypeID', i18n.t('importtask.labels.objecttype'), null, ObjectType ) );
form.add( new ListFormConfig( 'LocationTypeID', i18n.t('importtask.labels.locationtype'), null, LocationType ) );
const config = form.config;

export default {
  mixins: [formmixin],
  props: {
    destination: {}
  },
  components: {
    modal: ModalComponent
  },
  data() {
    return {
      formError: null,
      modelState: null,
      formControl: form,
      formItems: config
    };
  },
  async mounted() {
    this.formControl.loadData({});
  },
  methods: {
    generate() {
      let id = null;
      if (this.destination === 13) {
        id = this.formItems.ObjectTypeID.value;
      }
      if (this.destination === 10) {
        id = this.formItems.LocationTypeID.value;
      }
      this.$emit('generate', id);
    },
    closeCallback() {
      this.$emit('close');
    },
    manualClose() {
      this.$refs.modal.manualClose();
      this.closeCallback();
    }
  }
};
</script>
